import axios from 'axios';
import Vue from 'vue';
import zenScroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleLoadSharpsringScriptUrl,
    handleSetSharpspringScript,
    handleSharpspringSubmit,
    setCaptchaEuScript,
} from '../utils';
import { getFormRenderToken } from '../services/anti-bot';
import { isCaptchaEnabled } from '../services/captcha';

Vue.component('configurator-blind-booking', {
    props: {
        siteHandle: {
            value: String,
        },
        options: {
            value: Array,
        },
        colors: {
            value: Array,
        },
        inputs: {
            value: Array,
        },
        captchaEuPublicKey: {
            value: String,
        },
        stores: {
            value: Object,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
    },

    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            isEditionExpanded: true,

            edition: null,
            color: null,
            selectedColor: '',
            selectedEdition: '',
            image: null,
            selectedBrandStore: '',
            store: '',

            apiRequestLoading: false,
            editionOptions: [],
            editionOptionIndex: 0,
            colorOptions: [],
            colorOptionIndex: 0,
            formInput: null,
            price: 0,
            editionPrice: 0,
            colorPrice: 0,
        };
    },

    computed: {
        toggleButtonLoadingClass() {
            return this.submitting ? 'button--loading' : '';
        },

        toggleExpandBox() {
            return this.isEditionExpanded ? 'active' : '';
        },
    },

    watch: {
        /**
         * Set edition when index is updated.
         *
         * @returns {Void}
         */
        editionOptionIndex(value) {
            this.edition = this.editionOptions[value];
            this.selectedEdition = this.editionOptions[value].title;
            this.editionPrice = this.editionOptions[value].price;
        },

        editionPrice() {
            this.price = Number(this.editionPrice) + Number(this.colorPrice);
        },

        colorPrice() {
            this.price = Number(this.editionPrice) + Number(this.colorPrice);
        },
    },

    mounted() {
        this.editionOptions = this.options;
        this.colorOptions = this.colors;
        this.formInput = this.inputs[0];

        this.edition = this.editionOptions[0];
        this.selectedEdition = this.editionOptions[0].title;

        //set last element as default color
        const colorLenght = this.colorOptions.length - 1;
        this.color = this.colorOptions[colorLenght];
        this.selectedColor = this.colorOptions[colorLenght].colorValue;
        this.colorPrice = this.colorOptions[colorLenght].price;
        this.image =
            this.colorOptions[colorLenght].images[this.editionOptionIndex];
        this.colorOptionIndex = colorLenght;

        this.editionPrice = this.editionOptions[0].price;

        this.setColors();

        handleSetSharpspringScript(
            this.siteHandle,
            this.sharpspringBaseUrl,
            this.sharpspringEndpointId,
            'prebooking',
        );
        handleLoadSharpsringScriptUrl(
            this.siteHandle,
            this.sharpspringScriptUrl,
        );

        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
    },

    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
                zenScroll.center(firstError);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                formData.append('formRenderToken', this.formRenderToken);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);

                const result = response.data;
                if (result.data.errors) {
                    this.submitting = false;
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    this.scrollToFirstError();
                    return;
                }

                handleSharpspringSubmit(
                    this.siteHandle,
                    this.sharpspringEndpointId,
                );
                this.errors.clear();

                this.sendGTMData();

                window.location = window.location.pathname + '/thank-you';
            } catch (e) {
                throw new Error(e);
            }
        },

        sendGTMData() {
            const country =
                this.siteHandle == 'default'
                    ? 'mgMotorsEurope'
                    : this.siteHandle;

            if (checkCCM19Consent() || checkOneTrustConsent()) {
                if (!window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                }

                window.dataLayer.push({
                    event: 'lead',
                    lead_type: 'Prebooking',
                    car_type: this.model,
                    page_path: window.location.href,
                    country: `${country} - ${this.$root.languageCode}`,
                });
            }
        },

        toggleEditionButton(index) {
            return this.editionOptionIndex == index
                ? 'switch-button--selected'
                : '';
        },

        setActiveColor(index, event) {
            event.preventDefault();

            this.colorOptionIndex = index;
            this.color = this.colorOptions[index];
            if (
                this.colorOptions[index].images[this.editionOptionIndex] !==
                undefined
            )
                this.image =
                    this.colorOptions[index].images[this.editionOptionIndex];
            else this.image = this.colorOptions[index].images[0];

            this.selectedColor = this.colorOptions[index].colorValue;
            this.colorPrice = this.colorOptions[index].price;
        },

        activeColor(index) {
            return this.colorOptionIndex == index
                ? 'color__circle-wrapper--active'
                : '';
        },

        toggleConfiguratorSwitchSelect(index) {
            return this.editionOptionIndex == index
                ? 'configurator-switch-select__text--visible'
                : '';
        },

        editionSpecifications(index) {
            return this.editionOptions[index].specifications;
        },

        handleSetEditionOption(index, event) {
            event.preventDefault();
            const allEditionTexts = document.querySelectorAll('#edition__text');

            allEditionTexts[this.editionOptionIndex].style.height = 0;
            this.editionOptionIndex = index;
            allEditionTexts[this.editionOptionIndex].style.height = 'auto';
            if (this.color.images[this.editionOptionIndex] !== undefined)
                this.image = this.color.images[this.editionOptionIndex];
            else this.image = this.color.images[0];
        },

        handleSetColorOption(index) {
            this.colorOptionIndex = index;
        },

        setColors() {
            const allColors = document.querySelectorAll('#color__button');

            for (let i = 0; i < allColors.length; i++) {
                allColors[i].style.backgroundColor = this.colorOptions[i].color;
            }
        },

        checkEditionExpanded(index) {
            if (this.isEditionExpanded) return true;

            if (this.editionOptionIndex === index) {
                return true;
            }

            return false;
        },

        expandEditions() {
            this.isEditionExpanded = !this.isEditionExpanded;
        },
    },
});
